import React from 'react'
import { Link } from "react-router-dom";
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'
import CardUI from '../../../../widgets/layout/CardUI'
import RemarksModalSF from './RemarksModalSF'
import './LoanSizing.css'

const LoanSizingCalcUI = ({ context, loan, loanSizing2, loanSizingSmall2, onRefreshClick, sizing,
  onUpdateRemarksClick, updateRemarksMode, onCancelRemarksClick, objectCode, objectId, selectedloanClassic2Remarks,
  onShowDetails, showDetailsMode, toggleEditable, editable
}) =>
  <div className='c_ln_sz'>

    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Sizing</b></span>
        </div>
      }
      right={
        <span />
      }
    />

    {
      <div className='g_flex_h'>
        <span />
        <span>
          <UpdateProvisionals showDetailsMode={showDetailsMode} onShowDetails={onShowDetails} />
          <Link to='#' onClick={toggleEditable}>Details</Link>
        </span>
      </div>
    }

    <CardUI title='For classic loan' className='g_m_top_50'>
      <LoanSizingInnerUI
        loanSizing2={loanSizing2}
        sizing={sizing} onUpdateRemarksClick={onUpdateRemarksClick} editable={editable}
      />
    </CardUI>

    <CardUI title='For small loan' className='g_m_top_100'>
      <LoanSizingInner2UI
        loanSizing2={loanSizingSmall2}
        sizing={sizing} onUpdateRemarksClick={onUpdateRemarksClick} editable={editable}
      />
    </CardUI>

    <RemarksModalSF context={context} account={loan.account}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} objectCode={objectCode} objectId={objectId}
      selectedRemarks={selectedloanClassic2Remarks}
    />
  </div>

const LoanSizingInnerUI = ({
  sizing, onUpdateRemarksClick, editable,
  loanSizing2
}) =>
  <table>
    <tbody>
      <RowUI loanSizing2={loanSizing2} id='1' name='freeCashCheck' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      {/*<RowUI loanSizing2={loanSizing2} id='2' name='loanAmount' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />*/}
      <RowUI loanSizing2={loanSizing2} id='2' name='marginCheck' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      <RowUI loanSizing2={loanSizing2} id='3' name='netWorth' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      <RowUI loanSizing2={loanSizing2} id='' name='minLoanAmountCL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      <RowUI loanSizing2={loanSizing2} id='' name='maxLoanAmountCL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
    </tbody>
  </table >

const LoanSizingInner2UI = ({
  sizing, onUpdateRemarksClick, editable,
  loanSizing2
}) =>
  <table>
    <tbody>
      <RowUI loanSizing2={loanSizing2} id='1' name='freeCashCheckSL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      {/*<RowUI loanSizing2={loanSizing2} id='2' name='loanAmountSL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />*/}
      <RowUI loanSizing2={loanSizing2} id='2' name='netWorthSL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      <RowUI loanSizing2={loanSizing2} id='' name='minLoanAmountSL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
      <RowUI loanSizing2={loanSizing2} id='' name='maxLoanAmountSL2' onUpdateRemarksClick={onUpdateRemarksClick} editable={editable} sizing={sizing} />
    </tbody>
  </table >


const RowUI = ({ loanSizing2, id, name, onUpdateRemarksClick, sizing, editable }) =>
  <>
    <tr>
      <td>
        <span className='g_m_right_50 g_no_wrap_2'>{id}</span>
      </td>
      <td className='name'>
        <Desc name={name} />
      </td>
      <td className='g_text_right data' >
        {loanSizing2[name] && loanSizing2[name].amount}
      </td>
      <td>
        {
          sizing && editable &&
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onUpdateRemarksClick}
            data-object-code='loan_sizing' data-object-id={name} >
          </span>
        }
      </td>
    </tr>
    {
      loanSizing2[name] && loanSizing2[name].remarks &&
      <tr><td />
        <td colSpan='6' className='g_info g_small'>{loanSizing2[name].remarks}</td>
      </tr>
    }
    {
      loanSizing2[name] && loanSizing2[name].formula && editable &&
      <tr><td />
          <td colSpan='6' className='g_muted g_small'>{loanSizing2.financialYear}: {loanSizing2[name].formula}</td>
      </tr>
    }
  </>

const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'freeCashCheck':
        case 'freeCashCheckSL2':
          return 'Free cash check'
        case 'loanAmount':
        case 'loanAmountSL2':
          return 'Loan amount'
        case 'marginCheck':
          return 'Margin check'
        case 'netWorth':
        case 'netWorthSL2':
          return 'Net worth'
        case 'minLoanAmountCL2':
        case 'minLoanAmountSL2':
          return 'Offered loan amount'
        case 'maxLoanAmountCL2':
        case 'maxLoanAmountSL2':
          return 'Maximum loan amount'
        default:
          return name
      }
    })()}
  </span>

const UpdateProvisionals = ({ showDetailsMode }) =>
  <div className='g_flex_h'>
    <SpinnerUI show={showDetailsMode} className='g_m_right_50' />
  </div>

export default LoanSizingCalcUI
